// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2024 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { myListsOverviewStyles } from "@turnerBlueprint/App/Widgets/MyListsOverview/MyListsOverview";
import { LazyImageStyle } from "@turnerBlueprint/MobiusOverrides/LazyImage";
import { fontConfig } from "@turnerBlueprint/XDL/PreStyle/typography";
import { color, ellipsis, linkArrowStyle, xScreen } from "@turnerBlueprint/XDL/Utilities";
import { css } from "styled-components";

myListsOverviewStyles.wrapper = {
    css: css`
        display: flex;
        border: 1px solid ${color("common.border")};
        flex-direction: column;
    `,
};
myListsOverviewStyles.heading = {
    css: css`
        display: flex;
        justify-content: space-between;
        padding: 9px 13px;
        align-items: center;
        border-bottom: 1px solid ${color("common.border")};
    `,
};
myListsOverviewStyles.title = {
    variant: "h3",
    forwardAs: "p",
    css: css`
        margin-bottom: 0;
    `,
};
myListsOverviewStyles.link = linkArrowStyle("small", {
    css: css`
        align-self: center;
    `,
});

myListsOverviewStyles.centeredContent = {
    css: css`
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: center;
    `,
};

myListsOverviewStyles.body = {
    css: css`
        padding: 13px;
        padding-top: 12px;
        display: flex;
        flex-direction: column;
        gap: 12px;

        ${xScreen("lte", "md")} {
            flex-direction: row;
            flex-wrap: nowrap;
        }

        ${xScreen("lt", "sm")} {
            flex-direction: column;
        }
    `,
};
myListsOverviewStyles.createListModal = {
    sizeVariant: "small",
};

myListsOverviewStyles.listCard = {
    css: css`
        display: flex;
        gap: 12px;

        ${LazyImageStyle} {
            flex: 0 0 52px;
        }
    `,
};
myListsOverviewStyles.listImage = {
    width: "52px",
    height: "52px",
    css: css`
        min-width: 52px;
        object-fit: contain;
    `,
};

myListsOverviewStyles.listTitle = {
    typographyProps: {
        size: 12,
        lineHeight: "14px",
        weight: fontConfig.weight.bold,
        css: css`
            ${ellipsis(2)}
            text-overflow: ellipsis;
            max-width: 180px;
            display: inline-block;
        `,
    },
    color: "text",
};

myListsOverviewStyles.infoContainer = {
    css: css`
        display: flex;
        flex-direction: column;
        gap: 8px;
    `,
};

myListsOverviewStyles.listInfoText = {
    size: 12,
    lineHeight: "14px",
};
